import { Box, Typography } from "@mui/material"
import type { FC } from "react"

import type { PayFileInvoiceLineFields } from "../hooks/usePayFileInvoiceColumns"

import { PayFileInvoicesSubTable } from "./PayFileInvoicesSubTable"

import { type PayFileListFieldsFragment, PayFileStatus } from "@/graphql/codegen/graphql"

interface PayFileRowDetailsProps {
  payFile: PayFileListFieldsFragment
  onSuccess: () => void
}

export const PayFileRowDetails: FC<PayFileRowDetailsProps> = ({ payFile, onSuccess }) => {
  // AK-5645 AC #1: Removing an invoice is offered on Pending pay files only.
  const canRemove = payFile.status === PayFileStatus.Pending

  if (!payFile.invoiceLines.length) {
    return (
      <Box className='px-4 py-3' data-testid={`pay-file.expanded-row.empty-state-${payFile.payFileId}`}>
        <Typography className='text-sm text-gray-700'>This pay file has no remaining invoices.</Typography>
      </Box>
    )
  }

  return (
    <Box data-testid={`pay-file.expanded-row.invoices-${payFile.payFileId}`}>
      <PayFileInvoicesSubTable
        data={payFile.invoiceLines as PayFileInvoiceLineFields[]}
        payFileId={payFile.payFileId}
        canRemove={canRemove}
        onSuccess={onSuccess}
      />
    </Box>
  )
}
